<template>
    <div class="planbord-left-index">
        <slot></slot>
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator';

    @Component
    export default class PlanbordGridLeftDataColumns extends Vue {
    }
</script>

<style lang="scss" scoped>
    .planbord-left-index {
        display: grid;
        grid-column: 1 / span var(--left-non-day-columns);
        grid-template-columns: subgrid;
        position: sticky;
        left: 0;
        z-index: 98;
        background: var(--main-background-color);
        border-left: 1px solid var(--cell-border-color);
    }
</style>
